@if (itemsSource && (itemsSource.length > 1 || disableAutoSelect)) {
    <div class="dark:bg-gray-700">
        <section class="rounded border border-solid border-black-200 dark:border-black-600 bg-white dark:bg-black-700 shadow-sm">
            <div class="px-4 py-3 border-b border-solid border-black-200 dark:border-black-600">
                <h3 class="text-blue text-lg">{{ label }}</h3>
            </div>
            <ul class="divide-y divide-black-200 dark:divide-black-600 list-none m-0 p-0 max-h-[50vh] overflow-y-auto">
                @for (item of itemsSource; track item; let i = $index) {
                    <li>
                        <button
                            (click)="selectItem(item)"
                            class="w-full text-left px-4 py-3 transition-colors duration-100 hover:bg-blue-50 dark:hover:bg-black-600 focus:outline-none focus:bg-blue-50 dark:focus:bg-black-600"
                            type="button">
                            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                        </button>
                    </li>
                }
            </ul>
        </section>
    </div>
}
